<template>
	<div class="long_row">

		<div class="row">
			<div class="col-12">
				<div class="sec_tp_msg ace_sec">
					<span>{{exploreCareerText}}</span>
				</div>
			</div>
		</div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="row">
          <div v-for="(career, i) in exploreCareers" class="col-6 explore-career result_row">
            <div class="pkg_entity_bx programs">
              <button @click.stop="goToCareerDetail(career)" class="ace_sec" :aria-label="'career ' + career.name">
                <span class="thumbnail_container">
                  <span class="thumbnail_container_inner">
                    <div class="default_thumb thumbnail_img" v-if="career.thumbnailURI" :class="setImageBgColor(career.thumbnailURI)">
                      <img v-bind:src="career.thumbnailURI" alt="Img">
                    </div>
                    <div v-else class="default_thumb">
                      <span class="ic ic-career"></span>
                    </div>
                  </span>
                  <span class="entity_title" :id="'careerTitle_' + i">
                    <v-clamp class="entity_title_txt" autoresize :max-lines="2">{{ career.name }}</v-clamp>
                  </span>

									<b-popover :target="'careerTitle_' + i" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + i">
										<div class="title_container">
											{{ career.name }}
										</div>
									</b-popover>
									<div :id="'entityNameContainer_' + i" class="title_container_popup"></div>
                </span>
              </button>
            </div>
          </div>
          <div class="col-6 explore-career result_row">
            <div class="pkg_entity_bx programs">
              <button @click="exploreCareersClicked" class="ace_sec">
                <span class="thumbnail_container">
                  <span class="thumbnail_container_inner">
                    <div class="default_thumb">
                      <span class="ic ic-career"></span>
                    </div>
                  </span>
                  <span class="entity_title career-title">
                    <span class="entity_title_txt">Explore<br />Careers</span>
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2 sec_msg">
      <div class="col-12 ace_sec">
        <span>You can also <a href="javascript://" @click="exploreProgramsClicked">explore all available programs.</a></span>
      </div>
    </div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import VClamp from 'vue-clamp'

	export default {
		name: 'learner-explore-careers',
		components: {
      VClamp
    },
		data: () => {
			return {
        exploreCareers: [],
				exploreCareerText: 'Check out some of these learning careers'
			}
		},
    created () {
      this.populateLearnerDashboradCareers()
    },
    beforeMount () {
      this.$root.$on('reloadLearnerDashboard', () => {
        this.populateLearnerDashboradCareers()
      })
    },
		methods: {
			...mapActions([
	      'loadLearnerExploreCareers'
	    ]),
      populateLearnerDashboradCareers () {
        this.loadLearnerExploreCareers().then(resp => {
          this.exploreCareers = resp
        })
      },
      exploreCareersClicked () {
        return this.$router.push({name: 'exploreCareerResults'})
      },
      exploreProgramsClicked () {
        return this.$router.push({name: 'exploreProgramResults'})
      },
      setImageBgColor (imageURL) {
        let getImageURL = imageURL.split('/')
        let getImageName = getImageURL[getImageURL.length - 1].match(/(.*)\.[\w]+$/)[1]
        return getImageName.replace(/\./g, '__')
      },
      goToCareerDetail (career) {
        return this.$router.push({name: 'careerHome', params: {code: career.pragyaSoc}, query: {returnTo: 'learnerDashboard', pageTitle: 'Back To Learner Dahsboard'}})
      }
		}
	}
</script>

<style scoped>
  .career-thumbnail {
    padding-top: 0px;
  }

  .career-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px !important;
  }

  .explore-career {
    margin: 0 !important;
    border-bottom: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerExploreCareers.vue